<template>
  <div
    :class="`tw-flex tw-rounded-lg tw-p-3 tw-justify-between tw-items-center tw-cursor-pointer
          ${isSelected ? 'tw-bg-white tw-shadow-md' : 'tw-bg-[#EEEFF2] tw-text-[#79849A]'}`"
  >
    <div class="tw-flex tw-gap-2 tw-items-center">
      <i :class="`${option.icon} ${isSelected ? 'tw-text-[#F1583D]' : ''}`" />
      <div class="tw-font-medium">
        {{ option.label }}
      </div>
    </div>
    <div v-if="isSelected && showCheckmark">
      <i class="fas fa-check tw-text-green-500" />
    </div>
  </div>
</template>

<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['option', 'isSelected', 'showCheckmark'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>
